import { getI18nInstance } from '@/locales/i18nInstance';
import { computed } from 'vue';
import type VueI18n from 'vue-i18n';

export function useI18n() {
    const i18n = getI18nInstance();

    function t(key: string, values?: VueI18n.Values): string {
        return i18n.t(key, values) as string;
    }

    function te(key: string) {
        return i18n.te(key);
    }

    function tc(key: string, choice?: number, values?: VueI18n.Values) {
        return i18n.tc(key, choice, values);
    }

    const locale = computed(() => {
        return i18n.locale;
    });

    return {
        t,
        te,
        tc,
        locale,
    };
}
